var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZluriBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 33,
    viewBox: "0 0 66 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_131_1731)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.7046,
    cy: 6.2222,
    r: 6.2222,
    fill: "#57E1FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.7044,
    cy: 6.22215,
    r: 5.26494,
    fill: "#D3FF57"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.7054,
    cy: 6.22211,
    r: 3.98859,
    fill: "#FF4B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8682 24.8632V10.42H44.6359V16.6996L44.5836 14.7851C44.5836 12.7617 45.3142 12.1464 45.814 11.6466C46.7713 10.6893 47.9153 10.2107 49.5027 10.2107H50.0783V14.2925H48.9794C47.9153 14.2925 47.0867 14.5803 46.4937 15.1559C45.918 15.7315 45.6302 16.5601 45.6302 17.6416V24.8632H40.8682Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3879 24.9975C28.7482 24.9975 27.4749 24.4655 26.5678 23.4014C25.6782 22.3199 25.2334 20.9906 25.2334 18.7753V10.4025H29.9955V18.9061C29.9955 19.5515 30.1873 20.0748 30.5711 20.476C30.9548 20.8772 31.4694 21.0778 32.1148 21.0778C32.7602 21.0778 33.2835 20.8772 33.6847 20.476C34.0859 20.0748 34.2865 19.5341 34.2865 18.8538V10.4025H39.0486V24.8456H35.2808V23.4411C34.715 24.0145 34.3658 24.205 33.5297 24.6018C32.5724 25.0561 31.6787 24.9975 30.5973 24.9975H30.3879Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8032 24.8888V10.4457H58.5653V24.8888H53.8032ZM51.9717 13.8995V10.4457H58.5653V13.8995H51.9717Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.7044,
    cy: 6.22225,
    r: 2.71224,
    fill: "#2D2828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 24.889V21.9323L10.4105 14.2136V14.6323L9.73017 13.795L10.2535 14.0566H4.05233V10.4458H15.7743V13.4025L9.36385 21.1212V20.7026L10.0441 21.5399L9.52085 21.2782H15.9313V24.889H4Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3871 24.889V5.78845H23.1492V24.889H18.3871ZM16.7649 9.24225V5.78845H23.1492V9.24225H16.7649Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_131_1731",
    x: 0.138208,
    y: 0,
    width: 65.6503,
    height: 32.7236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.86179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9309
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_1731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_1731",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZluriBlack);
export default __webpack_public_path__ + "static/media/zluri_black.90fa4e245a072ba741a98943f20d750d.svg";
export { ForwardRef as ReactComponent };